export default __webpack_public_path__ + "static/media/ic-bookmark.b572eaa3.svg";